;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"dafb711a2840e5100666408515ea42eeda6ba6cb"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/fem/dafb711a2840e5100666408515ea42eeda6ba6cb";import * as Sentry from '@sentry/nextjs'
import {getEnvironment, SENTRY_TRACES_SAMPLE_RATE} from 'sentry.utils'
import {env} from '~/config/env.mjs'
import {isProd} from '~/config/nodeEnv'

Sentry.init({
  dsn: env.NEXT_PUBLIC_SENTRY_DSN,
  debug: false,
  enabled: isProd,
  environment: getEnvironment(),
  tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
  integrations: [
    Sentry.replayIntegration({
      blockAllMedia: false,
    }),
    Sentry.thirdPartyErrorFilterIntegration({
      // Specify the application keys that you specified in the Sentry bundler plugin
      filterKeys: ['mercury-fem'],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 0.1,
})
